/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid, Snackbar } from '@material-ui/core';

import backgroundImg from 'images/bg/desktop/background.png';
import backgroundImgMobile from 'images/bg/mobile/bg.png';
import logo from 'images/logos/simbolo-bradesco.png';
import topLeftImg from 'images/bg/desktop/grafismo-lado-esquerdo.png';
import topCenterImg from 'images/bg/desktop/icone-e-obrigado.png';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
    minHeight: '100%',
    overflowY: 'auto',
    backgroundColor: theme.palette.neutral,
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundImage: `url(${backgroundImg})`,
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      backgroundImage: `url(${backgroundImgMobile})`,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '16%',
    paddingRight: '8%',
    paddingTop: '55%',
    zIndex: '99',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '0%',
      paddingRight: '0%',
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: '25%',
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: '16%',
    }
  },
  topLeftImg: {
    top: '3%',
    left: '0%',
    height: 'auto',
    position: 'absolute',
    width: '30%',
    [theme.breakpoints.up('lg')]: {
      top: '-5%',
      width: '25%',
    },
  },
  topCenterImg: {
    top: '3%',
    left: '18%',
    height: 'auto',
    position: 'fixed',
    width: '70%',
    [theme.breakpoints.up('lg')]: {
      width: '40%',
      top: '5%',
      left: '18%',
    },
  },
  logo: {
    top: '40%',
    left: '78%',
    height: 'auto',
    position: 'absolute',
    width: '20%',
    [theme.breakpoints.up('lg')]: {
      left: '68%',
      width: '25%',
      top: '25%',
    },
  },
}));

function Layout3({ children }) {
  const classes = useStyles();

  const dispatch = useDispatch();
  const snack = useSelector((state) => state.snackbar);

  const closeSnackbar = () => {
    dispatch({ type: 'CLOSE_SNACKBAR' });
  }

  return (
    <React.Fragment>
      <div className={classes.root}>
        <img alt="" className={classes.logo} src={logo} />
        <img alt="" className={classes.topLeftImg} src={topLeftImg} />
        <img alt="" className={classes.topCenterImg} src={topCenterImg} />
        <Grid className={classes.content} item style={{ 'width': '100%'}} xs={12}>
          {children}
        </Grid>
      </div>
      <Snackbar
        autoHideDuration={6000}
        message={snack.message}
        onClose={closeSnackbar}
        open={snack.show}
      />
    </React.Fragment>
  );
}

Layout3.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Layout3;
